module.exports = __webpack_public_path__ + "img/card.42ff81bf.svg";